import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useAuth } from "../context/AuthContext";
import { ButtonModalOnClickClose } from "../components/ButtonModalSelection";
import Form from "react-bootstrap/Form";
import { AxisDateTimeFull } from "../util/AxisDateTime";

export const UserNoteDelete = ({
  visible,
  close,
  user,
  userNote,
  onComplete,
}) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [responseError, setResponseError] = useState(null);
  const [response, setResponse] = useState(null);

  const onDelete = async (e) => {
    if (loading) return;
    setResponseError(null);
    e.preventDefault();
    setLoading(true);
    let status = null;
    try {
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          user_note_id: userNote?.id,
        },
      };

      const response = await authAxios().post(
        "/api/backoffice/users/user_note_delete",
        null,
        config,
      );

      setResponse(response);
      if (response?.request?.status !== null)
        status = response?.request?.status;
      if (response?.status !== null) status = response?.status;
    } catch (err) {
      console.log("error:");
      console.log(err);
    }
    setLoading(false);

    if (status !== null && status === 200) {
      onComplete(true);
      return;
    } else {
      setResponseError("Failed to delete user note");
    }
  };

  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          Delete User Note
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this note?
        <br />
        User: {user?.surname}, {user?.forename}
        <br />
        Note: {userNote?.type}
        <br />
        Issued: {AxisDateTimeFull(userNote?.created)}
        <Form.Control.Feedback
          type="invalid"
          style={responseError !== null ? { display: "block" } : null}
        >
          {responseError}
        </Form.Control.Feedback>
      </Modal.Body>
      <ButtonModalOnClickClose
        close={close}
        onClickFunc={onDelete}
        funcButtonName={"Delete"}
        loading={loading}
      />
    </Modal>
  );
};
